import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchPredesTransactions = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getPredesTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      impcCode: payload.params.impcCode,
    },
    queryStringParams: {
      selectedDays: payload.params.selectedDays,
      transactionDirection: payload.params.transactionDirection,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchPredesTransactions;
